module.exports = __webpack_public_path__ + "media/images/youtube_attribution-d64d34ea53966530b936a3e47c05b7a1.png";